import { combineReducers } from 'redux';

import committees from './committee-reducer';
import allMeetings from './all-committee-meetings-reducer';
import meetingDocuments from './meeting-documents-reducer';
import searchTerm from './search-reducer';
import selectedPolicyGroup from './policyGroup-reducer';
import requestedCommittees from './requestedCommittees-reducer';
import myCommittees from './myCommittees-reducer';
import currentTabs from './switchtab-reducer';
import mainTab from './switch-main-tab-reducer';
import message from './message-reducer';
import loadingState from './loadingBar-reducer';
import meetings from './top-meetings-reducer';
import committeeMeetings from './all-meetings-reducer';
import showMeetings from './show-meeting-reducer';
import myCommitteeTab from './my-committee-tab-reducer';
import calendarMessage from './committee-invite-reducer';
import committeeColleagues from './committee-colleagues';
import generatingDocument from './generating-document-reducer';
import rollCallState from './roll-call-reducer';
import pagination from './pagination-reducer';
import committeeFilter from './committee-filter-reducer';
import committeeDocuments from './committee-documents';
import documentFilterType from './document-filter-type';
import categoryFilterType from './category-filter-type';
import currentDocumentTopics from './current-document-tags-reducer';
import documentTags from './document-tags-reducer';
import documentFilter from './document-filters-reducer';
import meetingFilter from './meeting-filter-reducer';
import meetingFocus from './meeting-focus-reducer';
import meetingsLoading from './meetings-loading-reducer';
import documentsLoading from './documents-loading-reducer';
import filterButtonState from './filter-button-reducer';
import mostEngagedCommittees from './most-engaged-committees-reducer';
import expandAllDocuments from './expand-all-documents';
import hasSwitchedForDirectLink from './direct-link-committee-switch-reducer';
import rollCallAttendance from './roll-call-attendance-reducer';
import popUpMeetingID from './popup-error-reducer';
import documentLoading from './loading-document-reducer';


export default combineReducers( {
	                                committees,
	                                searchTerm,
	                                meetings,
	                                selectedPolicyGroup,
	                                requestedCommittees,
	                                myCommittees,
	                                currentTabs,
	                                message,
	                                loadingState,
	                                committeeMeetings,
	                                showMeetings,
	                                myCommitteeTab,
	                                calendarMessage,
	                                committeeColleagues,
	                                mainTab,
	                                generatingDocument,
	                                rollCallState,
	                                allMeetings,
	                                meetingDocuments,
	                                committeeFilter,
	                                pagination,
	                                committeeDocuments,
	                                documentFilterType,
	                                categoryFilterType,
	                                currentDocumentTopics,
	                                documentTags,
	                                documentFilter,
	                                meetingFilter,
	                                meetingFocus,
	                                meetingsLoading,
	                                documentsLoading,
	                                filterButtonState,
	                                mostEngagedCommittees,
	                                expandAllDocuments,
	                                hasSwitchedForDirectLink,
	                                rollCallAttendance,
	                                popUpMeetingID,
	                                documentLoading

                                } );